/* src/app/components/TextAdornment/styles.js */

export default theme => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    padding: theme.spacing.unit,
  },
  textWrapper: {
    marginLeft: theme.spacing.unit,
  },
});



// WEBPACK FOOTER //
// ./src/app/components/TextAdornment/styles.js